module.exports = __webpack_public_path__ + "static/img/mini_co.31d753e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/rebuild/mini_co.jpg
// module id = HvJ6
// module chunks = 1